import React from 'react'
import messageUtil from 'utils/messageUtil'

import { SocialWebSourcesWidget } from 'schemas/SocialWebSourcesWidgetSchema'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import { useDashboardWidgetData } from '../../../../../hooks/useWidgetState'
import { usePageConfigUser } from '../../../../../hooks/usePageConfig'
import { convertToAreaData } from '../utils'
import { colorSettings } from '../../utils'
import AreaChart from '../../../../visualization/Area'
import SourceDisplayType from '../../../../../enums/SourceDisplayType'

const Area = ({ widgetId }: { widgetId: number }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebSourcesWidget>(widgetId)
  const widgetData = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const pageConfigUser = usePageConfigUser()

  const { data } = widgetData
  const areaData = convertToAreaData(data, widgetSetting, pageConfigUser)

  const { ctDisplay, timeUnit, countType } = widgetSetting

  return (
    <AreaChart
      stacking={ctDisplay === SourceDisplayType.VALUE ? 'value' : 'percent'}
      timeUnit={timeUnit!.toLowerCase()}
      xAxisUnit="datetime"
      yAxisTitle={messageUtil.countType(countType!)}
      data={areaData}
      colorSettings={colorSettings}
      seriesHeader={messageUtil.tooltipSeriesHeader(widgetSetting.type!)}
    />
  )
}

export default Area
